const WHITE_LISTED_PAGES = ['', '/', '/tournaments'];
const FRESHDESK_CHAT_BOT_TOKEN = 'd0a37f09-4ea6-4fdd-b698-e44d1308f2b6';
const FRESHDESK_CHAT_BOT_HOST = 'https://pickleball.freshchat.com';
const FRESHDESK_SCRIPT_ID = 'Freshchat-js-sdk';
const FRESHDESK_SCRIPT_SRC = 'https://pickleball.freshchat.com/js/widget.js';
const FRESHDESK_WIDGET_UUID = '0796eb5d-c0cb-4368-a474-bf3fbf0f9fae';

export { FRESHDESK_CHAT_BOT_HOST, FRESHDESK_CHAT_BOT_TOKEN, FRESHDESK_SCRIPT_ID, FRESHDESK_SCRIPT_SRC, FRESHDESK_WIDGET_UUID, WHITE_LISTED_PAGES };
